// Simple seedable RNG (mulberry32) with save/restore of state,
// mirroring the original game's use of a saved RNG seed in savegames.
export class Rng {
  constructor(seed) {
    this.state = (seed === undefined ? (Date.now() ^ (Math.random() * 0xffffffff)) : seed) >>> 0;
  }

  next() {
    this.state = (this.state + 0x6d2b79f5) >>> 0;
    let t = this.state;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  }

  // random(n) -> integer in [0, n-1], like Turbo Pascal's Random(n)
  random(n) {
    if (n <= 0) return 0;
    return Math.floor(this.next() * n);
  }

  getState() {
    return this.state;
  }

  setState(s) {
    this.state = s >>> 0;
  }
}
